module.exports = __webpack_public_path__ + "static/media/29.83404b30.png";